'use client';

import React from 'react';
import { ApolloLink, HttpLink } from '@apollo/client';
import {
  ApolloNextAppProvider,
  InMemoryCache,
  ApolloClient,
  SSRMultipartLink,
} from '@apollo/client-integration-nextjs';
import ErrorBoundary, {
  ErrorBoundaryProvider,
} from '../components/features/ErrorBoundary';

interface ApolloWrapperProps extends React.PropsWithChildren {
  lomaUrlClient: string;
  lomaUrlServer: string;
  nonce?: string;
}

export function ApolloWrapper({
  children,
  lomaUrlClient,
  lomaUrlServer,
  nonce,
}: ApolloWrapperProps) {
  const isServer = typeof window === 'undefined';

  function makeClient() {
    const httpLink = new HttpLink({
      uri: isServer ? lomaUrlServer : lomaUrlClient,
      fetchOptions: { cache: 'no-store' },
    });

    const link = isServer
      ? ApolloLink.from([
          new SSRMultipartLink({
            stripDefer: false,
          }),
          httpLink,
        ])
      : ApolloLink.from([httpLink]);

    return new ApolloClient({
      cache: new InMemoryCache({
        typePolicies: {
          RetailerTranslations: { merge: true },
          RetailerSettings: { merge: true },
          RetailerTheme: { merge: true },
          GlobalSettings: { merge: true },
        },
      }),
      link,
      devtools: { enabled: process.env.NODE_ENV === 'development' },
    });
  }

  const handleError = (err: unknown) => {
    console.error('APOLLO ERROR', err);
  };

  return (
    <ApolloNextAppProvider
      makeClient={makeClient}
      extraScriptProps={nonce ? { nonce } : undefined}
    >
      <ErrorBoundaryProvider handleError={handleError}>
        <ErrorBoundary errorContent={null}>{children}</ErrorBoundary>
      </ErrorBoundaryProvider>
    </ApolloNextAppProvider>
  );
}
